export const WEBSITE_BUILDER_FORM_KEY_NAME = "__wb_form_key";